import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_regular/home')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  )
}
